import ActivateOrganisation from "./activateOrganisation"

export default ActivateOrganisation
